module.exports = __webpack_public_path__ + "static/media/imgFive.6549d40a.jpg";